import { Text } from '@shared/ui/antd';
import { Flex } from 'antd';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface EmptyStateProps {
  isSearch?: boolean;
}

export const EmptyState: FC<EmptyStateProps> = ({ isSearch }) => {
  const { t } = useTranslation('translation', { keyPrefix: 'dialogs' });

  const currentText = isSearch ? t('nothingFound') : t('emptyStateText');

  return (
    <Flex flex="1 1 0" align="center" justify="center" style={{ height: '100%', width: '100%' }}>
      <Text variant="md" fontWeight={500}>
        {currentText}
      </Text>
    </Flex>
  );
};
